import React from 'react';
import './InfoModal.css';

const InfoModal = ({ show, handleClose }) => {
  return (
    <div className={`modal ${show ? 'show' : ''}`}>
      <div className="modal-content">
        <span className="close" onClick={handleClose}>&times;</span>
        <h2>How to play...</h2>
        <p>- This chart shows how the price of an asset changes in real time.
            Your goal is to make a prediction on whether the price chart is going to go UP or DOWN. </p>
        <p>- You can change the amount to stake on the bet by simply clicking in the Stake input box and typing a new amount or by clicking one of the Quick Stake buttons</p>
        <p>- The Balance shows the available funds to play</p>
        <p>- Click the HIGHER button if you think the price chart will go up, and the LOWER button if it will go down. </p>
        <p>- The Purchase time is the time when all bets must be in for the next game</p>
        <p>- The Expiration time is the time when the game will end</p>
        <p>- Profit is the potential profit you will make if your prediction is correct. </p>
        <p>- When the expiration time runs out, you will be shown how much profit was gained or lost</p>
        <p>- Click New Game to start over</p>
        <p>- RTP for this game is 86%</p>
        
      </div>
    </div>
  );
};

export default InfoModal;
